import { FC } from 'react';
import {
  WbCardContent,
  WbTabPanel,
  WbViewTabs,
  WbTabsContext,
  WbViewTabItem,
} from '@agilelab/plugin-wb-platform';
import { Box, makeStyles } from '@material-ui/core';
import { useEditorPageContext } from '../context/useEditorPageContext';
import { TestCurrent } from './TestCurrent';
import { TestHistory } from './TestHistory';

const useStyles = makeStyles(theme => ({
  container: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
  },
  bar: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    border: `1px solid ${theme.palette.grey[200]}`,
    borderLeft: 'none',
    borderRight: 'none',
    borderTop: `none`,
  },
  toolsBar: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap' as const,
    gap: '8px',
  },
  tabs: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
    marginBottom: theme.spacing(1.5),
  },
}));

export const TestCard: FC = () => {
  const classes = useStyles();
  const { selectedTestTab, setSelectedTestTab } = useEditorPageContext();

  return (
    <WbTabsContext
      value={selectedTestTab}
      onValueChange={v => setSelectedTestTab(v as 'current' | 'history')}
    >
      <WbCardContent className={classes.container}>
        <Box className={classes.toolsBar}>
          <Box className={classes.tabs}>
            <WbViewTabs aria-label="Test sections">
              <WbViewTabItem value="current" title="Current" />
              <WbViewTabItem value="history" title="History" />
            </WbViewTabs>
          </Box>
        </Box>

        <WbTabPanel value="current">
          <TestCurrent />
        </WbTabPanel>
        <WbTabPanel value="history">
          <TestHistory />
        </WbTabPanel>
      </WbCardContent>
    </WbTabsContext>
  );
};
